import type { ComponentPropsWithoutRef, JSX } from 'react';

import { cx } from './internal/cx.js';

export type AvatarSize = 'sm' | 'md' | 'lg';

export interface AvatarProps extends Omit<ComponentPropsWithoutRef<'span'>, 'children'> {
  /** Display name used for initials fallback and image alt text. */
  alt: string;
  /** Optional profile photo URL. When absent, shows initials from alt. */
  src?: string;
  size?: AvatarSize;
}

function getInitials(alt: string): string {
  const trimmed = alt.trim();
  if (trimmed.length === 0) return '?';
  return trimmed.charAt(0).toUpperCase();
}

/** Circular avatar with optional image and initials fallback. */
export function Avatar({ alt, src, size = 'md', className, ...props }: AvatarProps): JSX.Element {
  const initials = getInitials(alt);

  return (
    <span
      className={cx('nrx-avatar', size !== 'md' && `nrx-avatar--${size}`, className)}
      {...props}
    >
      {src ? (
        <img className="nrx-avatar__image" src={src} alt={alt} />
      ) : (
        <span className="nrx-avatar__fallback" aria-hidden="true">
          {initials}
        </span>
      )}
    </span>
  );
}
